module.exports = __webpack_public_path__ + "static/media/bg-hills-mobile.217720f2.jpg";